const allProjects = [
  {
  title: 'WITAN',
  img: require('../img/witan.png'),
  description: 'A distributed reporting platform designed around anonymous submissions, tamper-evident storage, and structured review workflows for sensitive organisational disclosures.',
  focus: ['distributed systems', 'secure workflows', 'platform architecture'],
  githubUrl: 'https://github.com/PubXpo/witan-platform',
  techStack: ['Python', 'FastAPI', 'Cassandra'],
  },
  {
    title: 'Web3 Laliberté',
    img: require('../img/Web3LApp.png'),
    description: 'A donation and fulfilment platform designed around structured API boundaries, predictable order flows, and reliable service orchestration.',
    focus: ['APIs', 'fulfilment', 'service design'],
    githubUrl: 'https://github.com/PubXpo/Web3Laliberte.WebApp',
    techStack: ['C#', 'React', 'Docker'],
  },
  {
    title: 'Timepeace',
    img: "https://raw.githubusercontent.com/PubXpo/timepeace/main/img/landing_screen.png",
    description: 'A contractor invoicing and project-tracking platform shaped around consistent data modelling, controlled billing flows, and predictable validation.',
    focus: ['invoicing', 'data modelling', 'validation'],
    githubUrl: 'https://github.com/PubXpo/timepeace',
    techStack: ['Java', 'Bootstrap', 'MySQL'],
  },
  // {
  //   title: 'Vessel v Landings',
  //   img: require('../img/VessVLand.PNG'),
  //   description: 'A data analysis application examining relationships between UK vessel characteristics and fish landings through statistical exploration and visual modelling.',
  //   focus: ['analysis', 'modelling', 'visualisation'],
  //   githubUrl: 'https://github.com/PubXpo/VesVLand',
  //   techStack: ['Python', 'Docker', 'MongoDB'],
  // },
  // {
  //   title: 'EasyCal',
  //   img: require('../img/easycal.png'),
  //   description: 'An Android planning application designed for visually impaired students, with simplified navigation and structured access to academic calendar information.',
  //   focus: ['accessibility', 'navigation', 'mobile UX'],
  //   githubUrl: 'https://github.com/PubXpo/EasyCal',
  //   techStack: ['Kotlin', 'XML', 'Android Studio'],
  // },
];

export default allProjects;
